<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
    id: Number,
    thumbnail: String,
    text_header: String,
    creation_time: String,
    views: Number,
    comment_count: Number
})

let img_url = computed(() => {
    if (props.thumbnail === null) {
        return window.document.location.origin + '/img/background.jpeg'
    }
    return window.document.location.origin + '/' + props.thumbnail
})

</script>

<template>
    <router-link
        :to="`/conference/${props.id}`"
        class="conference-card"
    >
        <div
            class="conference-card-image"
            :style="{
                backgroundImage: `url('${img_url}')`
            }"
        ></div>
        <div class="conference-card-container">
            <div class="conference-card-text">
                {{ props.text_header }}
            </div>
            <div class="conference-card-footer">
                <div class="conference-card-footer-info">
                    <img
                        src="/svg/calendar_date.svg"
                        alt="Календарь"
                    />
                    {{
                        new Date(props.creation_time).toLocaleDateString(
                            'ru-RU',
                            { day: 'numeric', month: 'long', year: 'numeric' }
                        )
                    }}
                </div>
                <div class="conference-card-footer-info">
                    <img
                        src="/svg/views.svg"
                        alt="Глаз"
                    />
                    {{ props.views }}
                </div>
                <div class="conference-card-footer-info">
                    <img
                        src="/svg/comments.svg"
                        alt="Комментарии"
                    />
                    {{ props.comment_count }}
                </div>
            </div>
        </div>
    </router-link>
</template>

<style lang="scss" scoped>
.conference-card {
    display: block;
    height: 335px;
    background: #fff;
    box-shadow: 1px 1px 50px 10px #2632380d;
    border-radius: 5px;
    text-decoration: none;
    color: unset;

    &:hover {
        background-color: rgb(240, 240, 240);
        transition: background-color 0.2s;
    }
}

.conference-card-image {
    width: 100%;
    height: 140px;
    border-radius: 5px 5px 0 0;
    background-size: cover;
    background-position: center;
}

.conference-card-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 10px 25px 10px;
    height: 195px;
}

.conference-card-text {
    text-align: left;
    font-size: 17px;
    line-height: 25px;
}

.conference-card-footer {
    color: #a2a2a2;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    gap: 10px;
}

.conference-card-footer-info {
    display: flex;
    align-items: center;
    gap: 5px;
}
</style>
